import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    notificationData: null,
    loading: false
  },
  reducers: {
    getAllNotificationsStart: (state) => {
      state.loading = true;
      state.notificationData = null;
    },
    getAllNotificationSuccess: (state, { payload }) => {
      state.loading = false;
      state.notificationData = payload;
    },
    getAllNotificationFailure: (state) => {
      state.loading = false;
    },
    markAsReadStart: (state) => {
      state.loading = true;
    },
    markAsReadSuccess: (state) => {
      state.loading = false;
    },
    markAsReadFailure: (state) => {
      state.loading = false;
    }
  }
});

export const {
  getAllNotificationsStart,
  getAllNotificationSuccess,
  getAllNotificationFailure,
  markAsReadStart,
  markAsReadSuccess,
  markAsReadFailure
} = notificationSlice.actions;

export default notificationSlice.reducer;